"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderDefaultSchema = void 0;
exports.BoomiOrderDefaultSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    definitions: {
        Source: {
            enum: [
                'APPLE',
                'ZUORA'
            ],
            type: 'string'
        }
    },
    properties: {
        eventDate: {
            type: 'string',
            minLength: 10
        },
        sonosId: {
            type: 'string',
        },
        userCountry: {
            type: 'string',
        },
        source: {
            enum: [
                'APPLE',
                'ZUORA'
            ],
            type: 'string'
        },
        sourceType: {
            type: 'string',
        },
        messageId: {
            type: 'string',
            minLength: 5
        },
        productId: {
            type: 'string',
        },
        transactionId: {
            type: 'string',
            minLength: 5
        },
        originalTransactionId: {
            type: 'string',
            minLength: 5
        },
        originalPurchaseDate: {
            type: 'string',
            minLength: 10
        },
        eventType: {
            type: 'string',
        },
        eventInfo: {
            type: 'object',
        },
    },
    required: [
        'eventDate',
        'sonosId',
        'userCountry',
        'source',
        'sourceType',
        'messageId',
        'productId',
        'transactionId',
        'originalTransactionId',
        'originalPurchaseDate',
        'eventType',
        'eventInfo',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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